import React from 'react';
import { FormSummary } from '@alinta-digital/asg';
import { FuelSite } from '../../types';
import {
  capitalizeFirstLetter,
  resetFormContextError,
} from '../../utils/utils';
import { SummaryProps } from '../../types';
import { SummaryContent } from '../SummaryContent/';
import { FormContainerContext } from '../../contexts/FormContainerContext';

interface DebitDetailsSummaryProps extends SummaryProps {
  selectedElectricity: FuelSite[];
  selectedGas: FuelSite[];
  debiltDetails: {
    bankAccountName: string;
    bsbNumber: string;
    paymentMethod: string;
    bankAccountNumber: string;
  };
}

export const DebitDetailsSummary: React.FunctionComponent<DebitDetailsSummaryProps> = ({
  selectedElectricity,
  selectedGas,
  debiltDetails,
  showSummaryFields,
  onEditClick,
}) => {
  const {
    values: formContextValues,
    dispatch: formContextDispatch,
  } = React.useContext(FormContainerContext);

  const summaryData = [...selectedElectricity]
    .concat([...selectedGas])
    .map((fuel: FuelSite) => {
      return {
        label: {
          value: `${capitalizeFirstLetter(fuel.fuelType)} account number`,
          dataTestId: 'selectedFuelSummary_label',
        },
        content: {
          value: fuel.authAccountNumber,
          dataTestId: 'selectedFuelSummary_content',
        },
      };
    })
    .concat([
      {
        label: {
          value: 'Bank Transfer',
          dataTestId: 'paymentMethodSummary_label',
        },
        content: {
          value: debiltDetails.paymentMethod === 'bankTransfer' ? 'Yes' : 'No',
          dataTestId: 'paymentMethodSummary_content',
        },
      },
      {
        label: {
          value: 'Bank account name',
          dataTestId: 'bankAccountNameSummary_label',
        },
        content: {
          value: debiltDetails.bankAccountName,
          dataTestId: 'bankAccountNameSummary_content',
        },
      },
      {
        label: {
          value: 'BSB',
          dataTestId: 'bsbSummary_label',
        },
        content: {
          value: debiltDetails.bsbNumber,
          dataTestId: 'bsbSummary_content',
        },
      },
      {
        label: {
          value: 'Bank account number',
          dataTestId: 'bankAccountNumberSummary_label',
        },
        content: {
          value: debiltDetails.bankAccountNumber,
          dataTestId: 'bankAccountNumberSummary_content',
        },
      },
    ]);

  return (
    <FormSummary
      heading="Step 3: Bank details"
      body={
        showSummaryFields ? (
          <SummaryContent
            leftItems={summaryData.slice(0, Math.ceil(summaryData.length / 2))}
            rightItems={summaryData.slice(Math.ceil(summaryData.length / 2))}
          />
        ) : (
          undefined
        )
      }
      onEditClick={
        showSummaryFields
          ? () => {
              resetFormContextError(formContextValues, formContextDispatch, 2);
              onEditClick();
            }
          : undefined
      }
    />
  );
};
